import { getMarketingPathTitleMap } from './marketingPathIndex';

/** Path segment without leading slash or hash fragment. */
export function normalizeMarketingHref(href: string): string {
  const path = href.trim().replace(/^\//, '').split('#')[0]?.split('?')[0] ?? '';
  return path.replace(/\/$/, '');
}

export function isKnownMarketingPath(
  href: string,
  map = getMarketingPathTitleMap()
): boolean {
  const path = normalizeMarketingHref(href);
  if (!path) return true;
  return map.has(path);
}
